import React, { useState, useEffect } from "react";
import { getItem } from "../../utils/nauth";
import {
  AppBar,
  Toolbar,
  Typography,
  NameBadge,
  Box,
  SubTypography,
  Menu,
  MenuContainer,
  MenuTitleText,
  MuiSelect,
} from "./styles";
import {
  MenuItem,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import { useStore } from "../../store";
import { useCookies } from "react-cookie";
import moment from "moment";

export interface HeaderProps {
  server: string | "test" | "development" | "production" | "";
  label: string;
  isLogin: boolean;
  onClick: () => void;
  logoutHandler: () => void;
}

export const Header = ({
  server,
  label,
  logoutHandler,
  isLogin,
  onClick,
  ...rest
}: HeaderProps) => {
  const userRole = getItem("role");
  const outPutServerName = () => {
    if (server === "test") {
      return "test";
    } else if (server === "development") {
      return "dev";
    } else if (server === "production") {
      return "prod";
    } else {
      return "";
    }
  };

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [regionServer, setRegionServer] = useState("nearest");
  const [regionVal, setRegionVal] = useState("");
  const expires = moment().add("100", "y").toDate();
  const [cookies, setCookie] = useCookies();
  const [dlgStatus, setDlgStatus] = useState<boolean>(false);

  const MenuButtonHandler = () => {
    return openModal ? setOpenModal(false) : setOpenModal(true);
  };

  const handleChange = (event: any) => {
    setDlgStatus(true);

    setRegionVal(event.target.value);
  };

  const regionChange = (region: string) => {
    setCookie("region", region, { path: "/", expires });
    setRegionServer(region);

    setDlgStatus(false);

    logoutHandler();
  };

  useEffect(() => {
    setRegionServer(cookies.region ? cookies.region : "nearest");
  }, []);

  return (
    <AppBar {...rest} position="static">
      <Toolbar>
        <Box>
          <Typography sx={{ mt: "13px" }} variant="h5" onClick={onClick}>
            {label}
            <NameBadge>{outPutServerName()}</NameBadge>
          </Typography>
          {server === "production" ? (
            <MuiSelect
              value={regionServer}
              onChange={handleChange}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value="nearest">Nearest</MenuItem>
              <MenuItem value="seoul">Seoul</MenuItem>
              <MenuItem value="singapore">Singapore</MenuItem>
              <MenuItem value="mumbai">Mumbai</MenuItem>
            </MuiSelect>
          ) : (
            <MuiSelect
              value={regionServer}
              onChange={handleChange}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value="nearest">Nearest</MenuItem>
            </MuiSelect>
          )}
        </Box>

        <Box>
          <SubTypography
            sx={{ mr: "30px", color: "#D0BCFF", fontSize: "13.5px" }}
          >
            Role : {userRole}
          </SubTypography>

          {isLogin && (
            <SubTypography
              sx={{ cursor: "pointer", color: "#D0BCFF", fontSize: "13.5px" }}
              onClick={logoutHandler}
            >
              Log out
            </SubTypography>
          )}
          <Menu onClick={MenuButtonHandler} />

          <Modal open={openModal} onClose={MenuButtonHandler}>
            <MenuContainer>
              <MenuTitleText onClick={onClick}>
                KineMaster Console :: Templates{" "}
              </MenuTitleText>

              <MenuItem
                sx={{ mt: "5px", color: "#D0BCFF", fontSize: "13.5px" }}
              >
                Role : {userRole}
              </MenuItem>
              {isLogin && (
                <MenuItem
                  sx={{ mt: "5px", fontSize: "13.5px", color: "#D0BCFF" }}
                  onClick={logoutHandler}
                >
                  Log out
                </MenuItem>
              )}
            </MenuContainer>
          </Modal>
        </Box>
      </Toolbar>

      <Dialog open={dlgStatus} PaperProps={{ id: "openedDlg" }}>
        <DialogContent>
          <Box>
            <DialogContentText>
              Would you like to log out for region change?
            </DialogContentText>
          </Box>
          <Box>
            <DialogActions>
              <Button
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  ml: 10,
                }}
                onClick={() => {
                  setDlgStatus(false);
                }}
              >
                No
              </Button>

              <Button
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => {
                  regionChange(regionVal);
                }}
              >
                Yes
              </Button>
            </DialogActions>
          </Box>
        </DialogContent>
      </Dialog>
    </AppBar>
  );
};

export default Header;
